module.exports = __webpack_public_path__ + "static/media/text_dot.749a15dd.svg";